export default __webpack_public_path__ + "static/weel-homepage-animation-fallback-68087ebe2208eeb946aa57b79a272a70.png";